/* Syrup Oracle: per-type PDP recipe block.
     Syrups  -> up to 3 FULL Bar Book recipe cards that use this syrup.
     Mixers  -> no recipe list; a Rum Guide pointer + "the bar keeps a page open".
     Bitters -> a "reach for our bitters in these" link to classics that use bitters.
     Other   -> nothing (self-hides).
   Data from bar-book.json (the finder's dataset). The PDP info column is
   Vue-hydrated and re-renders after we run, so we repaint until it sticks. */
(function () {
  'use strict';
  var box = document.getElementById('so-pdp-recipes');
  if (!box) return;
  var title = box.getAttribute('data-title') || '';
  var type = (box.getAttribute('data-type') || '').toLowerCase();
  var barbook = box.getAttribute('data-barbook') || '/pages/the-bar-book';

  var GENERIC = ['cocktail', 'cocktails', 'syrup', 'syrups', 'tropical', 'original', 'mix', 'mixer', 'mixers', 'bg', 'reynolds', 'the', 'tiki', 'collection', 'kit', 'punch', 'bitters', 'bitter'];
  function coreOf(t) {
    return t.split(/\s+/).filter(function (w) {
      return GENERIC.indexOf(w.toLowerCase().replace(/[^a-z0-9]/g, '')) === -1 && w.trim() !== '';
    }).join(' ').trim();
  }
  function slugify(s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  var core = coreOf(title);
  var coreLc = core.toLowerCase(), coreSlug = slugify(core);

  var BB = 'https://cdn.shopify.com/s/files/1/0018/5715/9281/files/bar-book.json';
  function getBook() {
    try {
      var c = JSON.parse(sessionStorage.getItem('so-bb-doc-v1'));
      if (c && c.t && (Date.now() - c.t) < 3600000 && c.recipes) return Promise.resolve(c.recipes);
    } catch (e) {}
    var v = Math.floor(Date.now() / 600000);
    return fetch(BB + '?v=' + v).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (d) {
      var rs = d.recipes || [];
      try { sessionStorage.setItem('so-bb-doc-v1', JSON.stringify({ t: Date.now(), recipes: rs })); } catch (e) {}
      return rs;
    });
  }

  function ingHtml(r) {
    var lines = (r.ingredients || '').split('\n');
    var lis = '';
    lines.forEach(function (line) {
      var p = line.split('|');
      if (p.length < 2) return;
      var isBg = p[1].indexOf('BG Reynolds') !== -1;
      lis += '<li><span' + (isBg ? ' class="syrup"' : '') + '>' + esc(p[1].trim()) + '</span><span class="amt">' + esc(p[0].trim()) + '</span></li>';
    });
    return lis;
  }

  function syrupCards(recipes) {
    var seen = {}, primary = [], namesake = [];
    recipes.forEach(function (r) {
      var id = slugify(r.title || ''); if (!id || seen[id]) return;
      var syr = (r.syrups || []).map(function (s) { return String(s).toLowerCase(); });
      var ing = (r.ingredients || '').toLowerCase();
      if (syr.indexOf(coreSlug) !== -1 || ing.indexOf('bg reynolds ' + coreLc) !== -1) { seen[id] = 1; primary.push(r); }
      else if ((r.title || '').toLowerCase().indexOf(coreLc) !== -1) { seen[id] = 1; namesake.push(r); }
    });
    var picks = primary.concat(namesake).slice(0, 3);
    if (!picks.length) return '';
    var cards = picks.map(function (r) {
      var id = slugify(r.title);
      return '<article class="so-pdp-rc">' +
        '<h3 class="so-pdp-rc__name">' + esc(r.title) + '</h3>' +
        (r.lineage ? '<p class="so-pdp-rc__lineage">' + esc(r.lineage) + '</p>' : '') +
        '<ul class="so-pdp-rc__ings">' + ingHtml(r) + '</ul>' +
        (r.method ? '<p class="so-pdp-rc__method">' + esc(r.method) + '</p>' : '') +
        '<a class="so-pdp-rc__link" href="' + barbook + '#recipe-' + id + '">Full card &amp; batch it</a>' +
        '</article>';
    }).join('');
    return '<div class="so-rule so-pdp-recipes__rule"><span>Mix it into</span></div><div class="so-pdp-rc__grid">' + cards + '</div>';
  }

  function bittersLinks(recipes) {
    var seen = {}, hits = [];
    recipes.forEach(function (r) {
      var id = slugify(r.title || ''); if (!id || seen[id]) return;
      if ((r.ingredients || '').toLowerCase().indexOf('bitters') !== -1) { seen[id] = 1; hits.push({ id: id, t: r.title }); }
    });
    hits = hits.slice(0, 5);
    if (!hits.length) return '';
    var links = hits.map(function (x) { return '<a class="so-pdp-recipes__link" href="' + barbook + '#recipe-' + x.id + '">' + esc(x.t) + '</a>'; }).join('');
    return '<div class="so-rule so-pdp-recipes__rule"><span>Reach for ours here</span></div>' +
      '<p class="so-pdp-recipes__note">Anywhere a classic calls for a dash of bitters, reach for ours instead:</p>' +
      '<div class="so-pdp-recipes__list">' + links + '</div>';
  }

  function mixerBlock() {
    return '<div class="so-rule so-pdp-recipes__rule"><span>Pour it right</span></div>' +
      '<p class="so-pdp-recipes__note">The whole recipe is right on the bottle &ndash; just add your rum, shake, and pour. Not sure which rum? <a href="/pages/rum-guide">Read the Rum Guide</a></p>' +
      '<p class="so-pdp-recipes__pageopen">The bar keeps a page open &ndash; got a killer riff on this one? <a href="' + barbook + '#so-recipe-submit">Add it to the Bar Book</a></p>';
  }

  getBook().then(function (recipes) {
    var html = '';
    if (type === 'syrups') { if (core.length >= 3) html = syrupCards(recipes); }
    else if (type === 'mixers') { html = mixerBlock(); }
    else if (type === 'bitters') { html = bittersLinks(recipes); }
    if (!html) return;

    function paint() {
      var b = document.getElementById('so-pdp-recipes');
      if (b && b.innerHTML.indexOf('so-rule') === -1) { b.innerHTML = html; b.hidden = false; return true; }
      return false;
    }
    paint();
    [200, 500, 1000, 2000, 4000].forEach(function (ms) { setTimeout(paint, ms); });
    if (window.MutationObserver) {
      var mo = new MutationObserver(function () { paint(); });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 6000);
    }
  }).catch(function () { /* progressive enhancement only */ });
})();
